var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1011_27298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 7.79086 13.7909 6 16 6H56C58.2091 6 60 7.79086 60 10V30C60 32.2091 58.2091 34 56 34H16C13.7909 34 12 32.2091 12 30V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.019 15.1826L32.8575 25.1775H30.2432L32.4049 15.1826H35.019ZM46.0175 21.6366L47.3938 17.883L48.1854 21.6366H46.0175ZM48.9358 25.1775H51.3529L49.241 15.1826H47.0112C46.5084 15.1826 46.085 15.4709 45.8975 15.9153L41.9746 25.1775H44.7203L45.2653 23.6849H48.6188L48.9358 25.1775ZM42.1109 21.9146C42.1223 19.2769 38.4243 19.1306 38.4489 17.9519C38.4569 17.5938 38.8022 17.2125 39.5575 17.1149C39.9318 17.0672 40.9648 17.0285 42.1359 17.5621L42.5938 15.4417C41.9646 15.2168 41.1553 15 40.1484 15C37.564 15 35.7458 16.3578 35.7313 18.3037C35.7148 19.7427 37.0302 20.5451 38.019 21.0243C39.0384 21.514 39.3802 21.8283 39.3752 22.2659C39.3682 22.9365 38.562 23.2335 37.8118 23.2446C36.4966 23.265 35.7344 22.8932 35.1268 22.6129L34.6523 24.8042C35.2641 25.081 36.3915 25.3222 37.5587 25.3344C40.3061 25.3344 42.1029 23.9926 42.1109 21.9146ZM31.2835 15.1826L27.0476 25.1775H24.2844L22.1997 17.2008C22.0735 16.7105 21.9633 16.5301 21.579 16.323C20.9503 15.985 19.9124 15.6692 19 15.4728L19.0617 15.1826H23.5102C24.077 15.1826 24.5866 15.5555 24.7163 16.2012L25.8174 21.9853L28.537 15.1826H31.2835Z",
    fill: "#182E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1011_27298",
    x: 0,
    y: 0,
    width: 72,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.168627 0 0 0 0 0.196078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1011_27298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1011_27298",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.76488abff97948804831213037036312.svg";
export { ForwardRef as ReactComponent };